import { writable } from "svelte/store";

// Loose runtime shape — the Notification interface is also missing some
// fields we read in the UI (seenAt, emitterAvatarUrl). Any-typing the array
// keeps the existing call sites working without invasive interface changes.
export const notifications = writable<any[]>([]);
export const notificationCount = writable(0);
export const unreadNotifications = writable(0);
// Count of *unrated* ai_action rows for the trainer — drives the blue
// bubble on the bell icon (next to the red one) and on the "AI" tab chip
// inside the notifications screen. Kept in sync via fetchUnreadAiActions on
// boot/screen-mount, and decremented optimistically when a row is rated.
export const unreadAiActions = writable(0);
export const notificationQuery = writable("");
export const notificationsFilter = writable({
  onlyUnread: false,
  onlyComments: false
});
